import { FeatureCollection, Point } from "geojson";
import { LayerParams } from "../map/layer-manager";
import { ColorType } from "../models/color-type";
import { NormalizerAux } from "../services/normalizer-aux/normalizer-aux";
import * as turf from "@turf/turf";

/**
 * Estratégia de cálculo da grade do heatmap, para as camadas contínua ou discreta.
 */
export class HeatmapCalcStrategy {

  static factory(layerParams: LayerParams) {

    const { colorType } = layerParams;

    if (colorType == ColorType.DISCRETE) {
      return HeatmapCalcStrategy.discrete;
    }
    return HeatmapCalcStrategy.continuous;
  }

  static continuous(layerParams: LayerParams) {

    const { middleIndicesPluv, rainData, selectedTimestamp, tilesize } = layerParams;

    // Criar um normalizer a partir dos middle data.
    const valFunction = (value: number) => value;
    const normalizer = NormalizerAux.createNormalizer(middleIndicesPluv, valFunction);

    // Calcular o valor avg para cada estação.
    const zeroOrNormalize = (indicePluv: number) => (indicePluv == 0) ?
      indicePluv : normalizer(indicePluv);

    rainData.features.forEach(({properties}) => {
      properties.avg = zeroOrNormalize(properties[selectedTimestamp]);
    });

  }

  static discrete(layerParams: LayerParams) {

    const { rainData, selectedTimestamp } = layerParams;

    const multipliers: {[key: string]: number} = {
      'indice_pluv': 1/4,
      'quinzemin': 1/4,
      'trintamin': 1/2,
      'umahora': 1,
      'seishoras': 6,
      'dozehoras': 12,
      'vintequatrohoras': 24,
      'quarentaoitohoras': 48,
      'setentaduashoras': 72,
      'noventaseishoras': 96,
      'mes': 720
    };

    // Calcula os valores do campo avg para cada estação.
    rainData.features.forEach(({properties}) => {
      properties.avg = properties[selectedTimestamp] / multipliers[selectedTimestamp];
    });
  }

}

/**
 * Calcula a grade de interpolação de chuva
 * @param rainData estações usadas para interpolar a chuva.
 * @param tilesize tamanho de uma célula da grade, em km.
 * @return grade interpolada pelo atributo avg das estações.
 */
export function calcHeatmapGrid(rainData: FeatureCollection<Point>, tilesize: number) {

  return turf.interpolate(
    rainData,
    tilesize,
    { gridType: 'square', property: 'avg', units: 'kilometers', weight: 2 }
  );
}
